import React from "react";

const MemberCard = ({ img, title, desc }) => {
  return (
    <div className=" w-20  rounded-lg  min-w-[18rem] my-0 mx-auto h-[30rem] shadow-xl ">
      <div className="bg-indigo-200 h-48">
        {" "}
        <img src={img} alt="" className="h-full w-full" />
      </div>
      <div className="p-4">
        <h2 className="text-2xl mb-4 font-bold capitalize">{title}</h2>
        <p className="text-left w-full">{desc}</p>
      </div>
    </div>
  );
};

export default MemberCard;
